export const DJ_KEY = 'djKey';
export const DJ_COURT_SYSTEM_ID = 'djCsId';
export const DJ_REGION = 'djRegion';
